// extracted by mini-css-extract-plugin
export var preferences = "CookiePreferences-module--preferences--1yisX";
export var checkbox = "CookiePreferences-module--checkbox--2Eg48";
export var desc = "CookiePreferences-module--desc--O-4gL";